import { useResolvedLang } from '../../utils/resolveLang';
import React from 'react';
import { Link } from 'react-router-dom';

interface LinkButtonProps {
    to: string;
    className?: string;
    children: React.ReactNode;
}

const LinkButton: React.FC<LinkButtonProps> = ({ to, className = '', children }) => {
    const langWeb = useResolvedLang();
    return (
        <Link to={`/${langWeb}${to}`} className={`${className}`}>
            {children}
        </Link>
    );
};

export default LinkButton;